/*
 * @Description: 
 * @Author: kangkang
 * @Date: 2024-05-12 15:25:29
 * @LastEditTime: 2024-05-12 15:36:57
 * @LastEditors: kangkang
 * @Reference: 
 */
const main = () => import("@/views/tabBar.vue");
const Index = () => import("@/views/index");
const Video = () => import("@/views/index/video.vue");
const User = () => import("@/views/index/user.vue");
const MusicList = () => import("@/views/index/list.vue");
const Loading = () => import("@/views/index/loading.vue");
const Preview = () => import("@/views/index/preview.vue");
const Blank = () => import("@/views/index/blank.vue");
const Agreement = () => import("@/views/index/agreement.vue");
export default [
    {
        path: "/index",
        name: "index",
        component: main,
        redirect: {
            name: "video"
        },
        children: [
            {
                path: "/video",
                name: "video",
                component: Video,
                meta: {
                    name: "视频"
                }
            },
            {
                path: "/user",
                name: "user",
                component: User,
                meta: {
                    name: "我的"
                }
            }
        ]
    },
    {
        path: "/list",
        name: "list",
        component: MusicList,
        meta: {
            name: "音乐列表"
        }
    },
    {
        path: "/preview",
        name: "preview",
        component: Preview,
        meta: {
            name: "预览"
        }
    },
    {
        path: "/loading",
        name: "loading",
        component: Loading,
        meta: {
            name: "加载动画"
        }
    },
    {
        path: "/login",
        name: "login",
        component: Blank,
        meta: {
            name: "登录"
        }
    },
    {
        path: "/agreement",
        name: "agreement",
        component: Agreement,
        meta: {
            name: "协议"
        }
    }
];